<div  class="card_disabled">
  <div class="image_card-disabled">
    <img class="timer-img-size" src="./assets/images/ancillariesImage.svg" alt="Bag">
  </div>
  <div class="available">
    <span>{{"bannerExclamation.bannerExclamation_Available" | translate}}</span>
  </div>
  <div class="timer">
    <div class="timer-square">
      <div class="timer-number">{{hourBaggageDrop}}</div>
      <div class="timer-txt">{{"bannerExclamation.Hours" | translate}}</div>
    </div>
    <div class="timer-img"><img src="./assets/images/two_points.png" alt="points"></div>
    <div class="timer-square">
      <div class="timer-number">{{minutesBaggageDrop}}</div>
      <div class="timer-txt">{{"bannerExclamation.Minutes" | translate}}</div>
    </div>
  </div>
</div>